import React, { useCallback } from 'react';
import AsyncSelect from 'react-select-v3/async';
import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';
import debouncePromise from 'debounce-promise';

import { reactSelectStyles } from 'utils/style';
import { MenuList } from 'utils/select';
import { DRIVER_STATES } from 'components/CarrierDetails/Constants';

const t = {
  placeholder: 'Driver',
};

const DriverSelect = ({
  value,
  onChange = () => {
    /*noop*/
  },
  onKeyDown = () => {
    /*noop*/
  },
  ...props
}) => {
  const _getDrivers = useCallback(async (input) => {
    if (!input || input.length < 3) {
      return Promise.resolve([]);
    }

    const driverParams = {
      search: input,
      page_size: 0,
      ordering: 'user__first_name,user__last_name',
      fields: ['id', 'contact_name', 'vehicles', 'carrier', 'is_fleet_service'].join(','),
      status: DRIVER_STATES.active,
    };

    const [drivers] = await Promise.all([
      http.get(`${config.API_URL}mercury/drivers/?${serialize(driverParams)}`),
    ]);

    return drivers.map((driver) => {
      return driver;
    });
  }, []);

  const getDrivers = debouncePromise(_getDrivers, 500, {
    leading: true,
  });

  const getOptionLabel = useCallback((option) => {
    return option.contact_name;
  }, []);

  const getOptionValue = useCallback((option) => {
    return option.id;
  }, []);

  return (
    <AsyncSelect
      isClearable
      placeholder={t.placeholder}
      value={value}
      onChange={onChange}
      loadOptions={getDrivers}
      styles={reactSelectStyles}
      onKeyDown={onKeyDown}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      components={{ MenuList }}
      {...props}
    />
  );
};

export default DriverSelect;
